import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import {
  authGroupsKeys,
  RequestTypes,
} from '@core/react-query/features/authGroups'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useCreateProjectAuthGroup = (
  options?: UseMutationOptions<
    any,
    RequestErrorType,
    RequestTypes['createProjectAuthGroup']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...authGroupsKeys.createProjectAuthGroup,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: authGroupsKeys._def })
    },
    ...options,
  })
}
